<template>
  <v-card class="mx-auto" :loading="loading" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" xs="12" md="8">
          <BtnCircle tLabel="Atrás" tPosition="bottom" icon="mdi-arrow-left" color="grey darken-3" size="x-small" :to="{
            name: `${page_route}${store_mode ? '' : '.view'}`,
            params: {
              contractor_id: contractor_id,
              id: id,
            },
          }" />

          <span class="text-h6 ml-1">
            {{ $route.meta.title }}
          </span>
          <br />
          <small>
            {{ loading_contractor ? "" : contractor.name }}
          </small>
        </v-col>

        <v-col cols="12" xs="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab x-small class="ml-1" color="info" :loading="faqs_ldg" :disabled="faqs.length == 0"
                @click.stop="faqs_dlg = true">
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-form ref="form_data" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'GENERAL'" />
              </v-card-title>

              <v-divider />

              <v-card-text>
                <v-row dense>
                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.name" label="Nombre*" type="text" dense :rules="rules.required"
                      maxlength="50" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.first_surname" label="Apellido paterno*" type="text" dense
                      :rules="rules.required" maxlength="25" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.second_surname" label="Apellido materno" :rules="rules.text25"
                      type="text" dense maxlength="25" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <DatePicker label="Fecha de nacimiento" :model.sync="data.birthday" clean all_date :rules="contractor && contractor.req_birthday
                      ? rules.required
                      : []
                      " />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-autocomplete v-model="data.insurance_id" label="Aseguradora*" :rules="rules.required"
                      :items="insurances" item-value="id" :item-text="(item) => item.name" :loading="insurances_loading"
                      dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-select v-model="data.insured_type_id" label="Tipo de asegurado*" :rules="rules.required"
                      :items="insured_types" item-value="id" :item-text="(item) => item.insured_type"
                      :loading="insured_types_loading" dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-autocomplete v-model="data.insured_category_id" label="Categoría" :items="insured_categories"
                      item-value="id" :item-text="(item) => item.name" :loading="insured_categories_ldg" dense />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'CONFIGURACIÓN'" />
              </v-card-title>

              <v-divider />

              <v-card-text>
                <v-row dense>
                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.enrollment" label="ID SM*" type="text" dense :rules="rules.required"
                      maxlength="10" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.policy" label="Póliza*" type="text" dense :rules="rules.required"
                      maxlength="30" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.credential" label="Número de asegurado*" type="text" dense
                      :rules="rules.required" maxlength="20" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="8">
                    <v-text-field v-model="data.office_address" label="Nombre de oficina" :rules="rules.required"
                      type="text" dense maxlength="100" counter />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <DatePicker label="Vigencia*" :model.sync="data.validity" clean all_date :rules="rules.required" />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-autocomplete v-model="data.entity_id" label="Estado" :items="entities" item-value="id"
                      :item-text="(item) => item.entity" :loading="entities_loading" dense
                      @change="getMunicipalities()" />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-autocomplete v-model="data.municipality_id" label="Municipio" :items="municipalities"
                      item-value="id" :item-text="(item) => item.municipality" :loading="municipalities_loading"
                      dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.code_tax" label="RFC" :rules="rules.code_tax" type="text" dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.powered_amount" label="Suma potenciada" :rules="rules.required"
                      type="number" dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field v-model="data.assured_amount" label="Suma asegurada" :rules="rules.required"
                      type="number" dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <DatePicker label="Antigüedad" :model.sync="data.antiquity" clean all_date />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-switch v-model="data.has_special_conditions" class="mt-0 pt-0" label="Condiciones especiales"
                      dense />
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-switch v-model="data.user.active" class="mt-0 pt-0" label="Usuario sistema" dense />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" class="text-right">
            <BtnCircle :tLabel="store_mode ? 'Crear' : 'Editar'" tPosition="top"
              :icon="store_mode ? 'mdi-plus' : 'mdi-pencil'" :color="store_mode ? 'success' : 'info'" size="small"
              :click="handleSubmit" :loading="loading" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";

import {
  URL_API,
  headersToken,
  msgConfirm,
  msgAlert,
  rules,
} from "../../control";

import { catalog } from "../../requests/catalogRequest";
import { storeUpdate, show, index } from "../../requests/pageRequest";

import BtnCircle from "../../components/BtnCircle.vue";
import DatePicker from "../../components/DatePicker.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    BtnCircle,
    DatePicker,
    FaqDlg,
  },

  data() {
    return {
      page_route: "asegurados",
      id: this.$route.params.id ? this.$route.params.id : 0,
      contractor_id: this.$route.params.contractor_id,
      store_mode: this.$route.params.id ? false : true,
      login: this.$store.getters.getLogin,

      loading: false,

      data: {
        id: null,
        name: "",
        first_surname: "",
        second_surname: "",
        policy: "",
        credential: "",
        office_address: "",
        enrollment: "",
        validity: "",
        birthday: "",
        contractor_id: null,
        insurance_id: null,
        insured_type_id: null,
        user: {
          id: null,
          active: false,
          email: "",
        },
        municipality_id: null,
        entity_id: null,
        code_tax: "",
        powered_amount: "0",
        assured_amount: "0",
        antiquity: "",
        has_special_conditions: false,
        insured_category_id: null,
      },

      contractor: {},
      loading_contractor: true,

      rules: {},

      insured_types: [],
      insured_types_loading: true,

      insurances: [],
      insurances_loading: true,

      municipalities: [],
      municipalities_loading: false,

      entities: [],
      entities_loading: true,

      insured_categories: [],
      insured_categories_ldg: true,

      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },

  methods: {
    async handleSubmit() {
      let valid_user = true;

      if (
        this.data.user.active &&
        (this.data.enrollment == "" || !this.data.enrollment)
      ) {
        valid_user = false;
      }

      if (!valid_user) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Si se activa Usuario sistema el ID SM es obligatorio",
          ),
        );

        return;
      }

      if (!this.$refs.form_data.validate()) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );

        return;
      }

      const confirm = await this.$swal.fire(
        msgConfirm(
          `¿Confirma la ${this.store_mode ? "creación" : "edición"
          } del registro?`,
        ),
      );

      if (!confirm.isConfirmed) {
        return;
      }

      this.loading = true;

      try {
        this.data.user.email = this.data.credential;

        const obj = Object.assign({}, this.data);

        obj.user = JSON.stringify(obj.user);

        const response = await storeUpdate(
          "insureds",
          this.login.token,
          this.id,
          obj,
          this.login.id,
        );

        this.$swal.fire(
          msgAlert(
            response.success ? "success" : "error",
            response.message,
          ),
        );

        if (!response.success) {
          return;
        }

        this.$router.push({
          name: `${this.page_route}${this.store_mode ? "" : ".view"}`,
          params: {
            contractor_id: this.contractor_id,
            id:
              this.store_mode && response.data
                ? response.data.id
                : this.id,
          },
        });
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible guardar el registro"),
        );
      } finally {
        this.loading = false;
      }
    },

    async getMunicipalities() {
      this.municipalities = [];
      this.municipalities_loading = true;

      try {
        const response = await index(
          "municipalities/" + this.data.entity_id,
          this.login.token,
          [
            {
              name: "active",
              value: 1,
            },
            {
              name: "id",
              value: this.login.id,
            },
          ],
        );

        this.municipalities = response.data || [];
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar los municipios"),
        );
      } finally {
        this.municipalities_loading = false;
      }
    },

    async getFaqs() {
      this.faqs = [];
      this.faqs_ldg = true;

      try {
        const resp = await Axios.get(
          URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
          headersToken(this.login.token),
        );

        this.faqs = resp.data.data || [];
      } catch (err) {
        this.faqs = [];
      } finally {
        this.faqs_ldg = false;
      }
    },

    async getContractor() {
      this.loading_contractor = true;

      try {
        this.contractor = await show(
          "contractors",
          this.login.token,
          this.contractor_id,
        );
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar el contratante"),
        );
      } finally {
        this.loading_contractor = false;
      }
    },

    async getCatalogs() {
      try {
        const [
          insured_types_response,
          entities_response,
          insured_categories_response,
          insurances_response,
        ] = await Promise.all([
          catalog("insured_types", this.login.token),
          catalog("entities", this.login.token),
          catalog("insured_categories", this.login.token),
          index("insurances", this.login.token, [
            {
              name: "active",
              value: 1,
            },
            {
              name: "id",
              value: this.login.id,
            },
          ])
        ]);

        this.insured_types = insured_types_response || [];
        this.entities = entities_response || [];
        this.insured_categories = insured_categories_response || [];
        this.insurances = insurances_response.data || [];
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar los catálogos"),
        );
      } finally {
        this.insured_types_loading = false;
        this.entities_loading = false;
        this.insured_categories_ldg = false;
        this.insurances_loading = false;
      }
    },

    async getItem() {
      if (this.store_mode) {
        this.data.contractor_id = this.contractor_id;
        return;
      }

      this.loading = true;

      try {
        this.data = await show(
          "insureds",
          this.login.token,
          this.id,
        );

        if (!this.data.user) {
          this.data.user = {
            id: null,
            active: false,
            email: "",
          };
        }

        this.data.has_special_conditions = Boolean(
          this.data.has_special_conditions,
        );

        await this.getMunicipalities();
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar el asegurado"),
        );
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    this.rules = rules();

    this.getFaqs();
    this.getContractor();
    await this.getCatalogs();
    await this.getItem();
  },
};
</script>